<div 
  class="transcription" 
  appClickOutsideModal 
  (clickOutside)="closeModal(true)">
  <div class="transcription-close">
    <button
      type="button"
      class="transcription-close-button"
      (click)="closeModal(true)"
      aria-label="Close"
    >
      <span class="transcription-close-icon" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="transcription-container">
    <h1 
      class="transcription-title" 
      [ngClass]="{
      'border-video': transcriptionType === 'automatedTranscription',
      'border-ebook': transcriptionType === 'narratedBible'}"
      >{{transcriptionTitle}}
    </h1>
    <div class="transcription-item">
      <ng-container *ngIf="transcriptionType === 'automatedTranscription'">
        <ng-container *ngTemplateOutlet="automatedTranscription"></ng-container>
      </ng-container>
      <ng-container *ngIf="transcriptionType === 'narratedBible'">
        <ng-container *ngTemplateOutlet="narratedBible"></ng-container>
      </ng-container>
      <ng-container *ngIf="(transcriptions?.length === 0 || narratedBibles?.length === 0) && !loadingSkeleton">
  <ng-container *ngTemplateOutlet="notTranscription"></ng-container>
</ng-container>
      
      <app-skeleton-transcription 
        *ngIf="loadingSkeleton" 
        [loadingSkeleton]="loadingSkeleton">
      </app-skeleton-transcription>
    </div>
  </div>
</div>

<ng-template #automatedTranscription>
  <ng-container *ngFor="let transcription of transcriptions">
    <div class="transcription-list" (click)="goToWatch(transcription)">
      <span class="transcription-text">{{ transcription.startTime | timeFormat }}</span>
      <p 
        class="transcription-description" 
        [innerHTML]="transcription.lines[0] | highlightBibleSearch:searchTerm:'highlighted-search-transcripción'">
      </p>
    </div>
  </ng-container>
</ng-template>

<ng-template #narratedBible>
  <ng-container *ngFor="let narratedBible of narratedBibles">
    <div class="transcription-list" (click)="goToWatch(narratedBible)">
      <div class="transcription-info">
        <span class="transcription-text">{{ narratedBible.title }}</span>
        <span class="transcription-time">{{ narratedBible.startTime | timeFormat }}</span>
      </div>
      <p 
        class="transcription-description" 
        [innerHTML]="narratedBible.lines[0] | highlightBibleSearch:searchTerm:'highlighted-search-transcripción'">
      </p>
    </div>
  </ng-container>
</ng-template>

<ng-template #notTranscription>
  <div class="transcription-not-result">
    No se encontraron resultados para 
    <strong>"{{ searchTerm }}"</strong> 
    dentro de {{ transcriptionSourceLabel }}.
  </div>
</ng-template>